<template>
	<div class="msg-analysis-tar" v-if="!isError">
		<div class="msg-analysis-tar-info">
			<span class="msg-analysis-tar-img"></span>
			<span class="msg-analysis-tar-text">{{message.money}}<br/>已退款</span>
		</div>
		<div class="msg-analysis-tar-footer">
			<span>微信转账</span>
		</div>
	</div>
	<div class="msg-analysis-tar-error" v-else>
		转账消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisTransfer_accounts_r',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: '',
				isError: false
			}
		},
		methods:{
			format(){
				try {
					this.message = JSON.parse(this.msg.content);
				}catch (e) {
					this.isError = true
				}
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-tar-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-tar{
	    background: #ffffff;
	    position: relative;
	    border: 1px solid #e8e8e8;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
	}
	.msg-analysis-tar .msg-analysis-tar-info{
	    background-image: -moz-linear-gradient(to left,#ffd19f,#ff9770);
	    background-image: -o-linear-gradient(to left,#ffd19f,#ff9770);
	    background-image: -webkit-linear-gradient(to left,#ffd19f,#ff9770);
	    background-image: linear-gradient(to left,#ffd19f,#ff9770);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.msg-analysis-tar-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.msg-analysis-tar-info .msg-analysis-tar-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/transfer_accounts_r.png") no-repeat;
	    background-size:32px 32px;
	}
	.msg-analysis-tar-info .msg-analysis-tar-text{
	    line-height: 18px;
	    height: 36px;
	    overflow: hidden;
	}
	.msg-analysis-tar .msg-analysis-tar-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 10px;
	}
	.comp-chatting-c-empty{
		padding: 20px;
		text-align: center;
		color: #999999;
	}
</style>
